import { ofType } from 'redux-observable';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  addedTriggerAction,
  setCurrentTriggerAction
} from '../../reducers/actions';
import { TriggerService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_TRIGGER),
    switchMap(action =>
      TriggerService.create(action.trigger, store).pipe(
        switchMap(data =>
          concat(
            of(addedTriggerAction(data)),
            of(setCurrentTriggerAction(data))
          )
        ),
        catchError(retryAuthentication(action$, 'epics/triggers/addTrigger'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/triggers/addTrigger.js